/* eslint-disable arrow-body-style */
import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { dashboardPrefix } from './constants';

export const getDashboardGamePermissions: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${dashboardPrefix}/game/permissions`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<overviewOriginType>;
};
